export default __webpack_public_path__ + "static/media/lineup.5e7d5d08.png";